<template>
    <div class="about-initiative-form2">
        <slot name="how-register-modal"></slot>

        <div class="edit-info" v-if="getEditionMode">
            <b-button
                :variant="getIsDarkTheme ? 'outline-light' : 'outline-dark'"
                size="sm"
                @click="changeStatusDisabled(false)"
            >
                Editar informações
            </b-button>
        </div>

        <div class="msg-top">
            <span class="text-bold"
                >Assinale se sua iniciativa possui ou já realizou (marque todas que se aplicam) </span
            >
            <span
                >(Mesmo que você não tenha sede, é importante indicar um local em que está situada para que possamos
                inserir você no mapa.)</span
            >
        </div>

        <b-form @submit.stop.prevent="onSubmit" novalidate>
            <div class="lock-msg-top">
                <div class="msg">
                    {{
                        `Caso queira que suas informações ${
                            form.statusLock ? 'não sejam' : 'sejam'
                        } públicas, clique no botão abaixo.`
                    }}
                </div>

                <LockPP
                    :statusLock="Number(form.statusLock)"
                    :lockMsg="'Privado'"
                    :unlockMsg="'Público'"
                    @click="form.statusLock = Number(!form.statusLock)"
                    v-if="showLock"
                />
            </div>

            <b-form-group
                label="Fundação da iniciativa (somente ano)"
                label-for="initiativeYearCreated"
            >
                <b-form-input
                    id="initiativeYearCreated"
                    name="initiativeYearCreated"
                    v-model="form.initiativeYearCreated"
                    v-mask="'####'"
                    type="text"
                    placeholder="Digite aqui"
                    :disabled="getIsDisabled"
                    v-if="
                        !isPlatform ||
                            (isPlatform &&
                                getAuthorizationData &&
                                getAuthorizationData['tempo_iniciativa_existe'].value)
                    "
                ></b-form-input>

                <div class="invalid" v-if="form.initiativeYearCreated && form.initiativeYearCreated.length < 4">
                    Deve inserir 4 caracteres
                </div>

                <NoAuthorizationMsgPP
                    v-if="isPlatform && getAuthorizationData && !getAuthorizationData['tempo_iniciativa_existe'].value"
                />
            </b-form-group>

            <div class="row">
                <b-form-group class="col-md-6">
                    <div class="cep-label">
                        <label for="cep" class="required">CEP</label>
                        <div class="link">
                            <a href="https://buscacepinter.correios.com.br/app/endereco/index.php" target="_blank">
                                Não sei o meu CEP
                            </a>
                        </div>
                    </div>

                    <b-form-input
                        id="cep"
                        name="cep"
                        v-model="$v.form.cep.$model"
                        v-mask="'#####-###'"
                        type="text"
                        placeholder="Digite aqui"
                        :state="validateState('cep')"
                        :disabled="getIsDisabled"
                        @change="getAddressByCep()"
                        v-if="!isPlatform || (isPlatform && getAuthorizationData && getAuthorizationData['cep'].value)"
                    ></b-form-input>

                    <NoAuthorizationMsgPP
                        v-if="isPlatform && getAuthorizationData && !getAuthorizationData['cep'].value"
                    />

                    <b-form-invalid-feedback :state="validateState('cep')">
                        <div v-if="!$v.form.cep.required">
                            Campo obrigatório
                        </div>

                        <div v-if="!$v.form.cep.minLength">
                            Deve conter 9 caracteres
                        </div>
                    </b-form-invalid-feedback>
                </b-form-group>

                <b-form-group label="Estado" label-for="state" class="col-md-6 required">
                    <b-form-input
                        id="state"
                        name="state"
                        v-model="$v.form.state.$model"
                        placeholder="Digite aqui"
                        :state="validateState('state')"
                        :disabled="true"
                        v-if="
                            !isPlatform || (isPlatform && getAuthorizationData && getAuthorizationData['estado'].value)
                        "
                    ></b-form-input>

                    <NoAuthorizationMsgPP
                        v-if="isPlatform && getAuthorizationData && !getAuthorizationData['estado'].value"
                    />

                    <b-form-invalid-feedback :state="validateState('state')">
                        Campo obrigatório
                    </b-form-invalid-feedback>
                </b-form-group>
            </div>

            <b-form-group label="Rua/Alameda/Avenida/Travessa" label-for="street" class="required">
                <b-form-input
                    id="street"
                    name="street"
                    v-model="$v.form.street.$model"
                    placeholder="Digite aqui"
                    :state="validateState('street')"
                    :disabled="true"
                    v-if="!isPlatform || (isPlatform && getAuthorizationData && getAuthorizationData['rua'].value)"
                ></b-form-input>

                <NoAuthorizationMsgPP v-if="isPlatform && getAuthorizationData && !getAuthorizationData['rua'].value" />

                <b-form-invalid-feedback :state="validateState('street')">
                    Campo obrigatório
                </b-form-invalid-feedback>
            </b-form-group>

            <div class="row">
                <b-form-group label="Número" label-for="number" class="col-md-6">
                    <b-form-input
                        id="number"
                        name="number"
                        v-model="form.number"
                        placeholder="Digite aqui"
                        :disabled="getIsDisabled"
                        v-if="
                            !isPlatform || (isPlatform && getAuthorizationData && getAuthorizationData['numero'].value)
                        "
                    ></b-form-input>

                    <NoAuthorizationMsgPP
                        v-if="isPlatform && getAuthorizationData && !getAuthorizationData['numero'].value"
                    />
                </b-form-group>

                <b-form-group label="Complemento" label-for="complement" class="col-md-6">
                    <b-form-input
                        id="complement"
                        name="complement"
                        v-model="form.complement"
                        placeholder="Digite aqui"
                        :disabled="getIsDisabled"
                        v-if="
                            !isPlatform ||
                                (isPlatform && getAuthorizationData && getAuthorizationData['complemento'].value)
                        "
                    ></b-form-input>

                    <NoAuthorizationMsgPP
                        v-if="isPlatform && getAuthorizationData && !getAuthorizationData['complemento'].value"
                    />
                </b-form-group>
            </div>

            <div class="row">
                <b-form-group label="Bairro" label-for="burgh" class="col-md-6 required">
                    <b-form-input
                        id="burgh"
                        name="burgh"
                        v-model="$v.form.burgh.$model"
                        placeholder="Digite aqui"
                        :state="validateState('burgh')"
                        :disabled="getIsDisabled"
                        v-if="
                            !isPlatform || (isPlatform && getAuthorizationData && getAuthorizationData['bairro'].value)
                        "
                    ></b-form-input>

                    <NoAuthorizationMsgPP
                        v-if="isPlatform && getAuthorizationData && !getAuthorizationData['bairro'].value"
                    />

                    <b-form-invalid-feedback :state="validateState('burgh')">
                        Campo obrigatório
                    </b-form-invalid-feedback>
                </b-form-group>

                <b-form-group class="col-md-6 required" v-if="showDistrict">
                    <div class="label-created required">
                        Distrito
                        <span id="rg-rne-help" class="icon-tooltip">
                            <img :src="require(`@/assets/Cadastro/responsavel/help-icon.svg`)" alt=""
                        /></span>

                        <b-tooltip target="rg-rne-help">
                            Distrito é uma divisão administrativa de um município ou cidade, que pode compreender um ou
                            mais bairros. Não tem uma estrutura administrativa própria e está subordinado à prefeitura
                            regional ao qual pertence. É formada por um ou mais bairros.
                        </b-tooltip>
                    </div>

                    <b-form-select
                        id="district"
                        name="district"
                        v-model="$v.form.district.selected.$model"
                        :options="form.district.options"
                        :state="validateState('district')"
                        :disabled="getIsDisabled"
                        v-if="
                            !isPlatform ||
                                (isPlatform && getAuthorizationData && getAuthorizationData['distrito'].value)
                        "
                    ></b-form-select>

                    <NoAuthorizationMsgPP
                        v-if="isPlatform && getAuthorizationData && !getAuthorizationData['distrito'].value"
                    />

                    <b-form-invalid-feedback :state="validateState('district')">
                        Campo obrigatório
                    </b-form-invalid-feedback>
                </b-form-group>
            </div>

            <b-form-group label="Cidade" label-for="city" class="required">
                <b-form-input
                    id="city"
                    name="city"
                    v-model="$v.form.city.$model"
                    placeholder="Digite aqui"
                    :state="validateState('city')"
                    :disabled="true"
                    v-if="!isPlatform || (isPlatform && getAuthorizationData && getAuthorizationData['cidade'].value)"
                ></b-form-input>

                <NoAuthorizationMsgPP
                    v-if="isPlatform && getAuthorizationData && !getAuthorizationData['cidade'].value"
                />

                <b-form-invalid-feedback :state="validateState('city')">
                    Campo obrigatório
                </b-form-invalid-feedback>
            </b-form-group>

            <div class="row">
                <b-form-group label="Telefone com DDD (institucional)" label-for="phone" class="col-md-6">
                    <b-form-input
                        id="phone"
                        name="phone"
                        v-model="form.phone"
                        placeholder="Digite aqui"
                        v-mask="form.phone === null || form.phone.length <= 14 ? '(##) ####-####' : '(##) #####-####'"
                        :disabled="getIsDisabled"
                        v-if="
                            !isPlatform ||
                                (isPlatform &&
                                    getAuthorizationData &&
                                    getAuthorizationData['telefone_institucional'].value)
                        "
                    ></b-form-input>

                    <div class="invalid" v-if="form.phone && form.phone.length < 14">
                        Quantidade de dígitos insuficiente
                    </div>

                    <NoAuthorizationMsgPP
                        v-if="
                            isPlatform && getAuthorizationData && !getAuthorizationData['telefone_institucional'].value
                        "
                    />
                </b-form-group>

                <b-form-group label="E-mail (institucional)" label-for="email" class="col-md-6">
                    <b-form-input
                        id="email"
                        name="email"
                        v-model="form.email"
                        placeholder="Digite aqui"
                        :disabled="getIsDisabled"
                        v-if="
                            !isPlatform ||
                                (isPlatform &&
                                    getAuthorizationData &&
                                    getAuthorizationData['email_institucional'].value)
                        "
                    ></b-form-input>

                    <NoAuthorizationMsgPP
                        v-if="isPlatform && getAuthorizationData && !getAuthorizationData['email_institucional'].value"
                    />
                </b-form-group>
            </div>

            <b-form-group
                label="Abrangência da iniciativa"
                label-for="area"
                class="required"
            >
                <b-form-select
                    id="area"
                    name="area"
                    v-model="$v.form.area.selected.$model"
                    :options="form.area.options"
                    :state="validateState('area')"
                    :disabled="getIsDisabled"
                    v-if="
                        !isPlatform ||
                            (isPlatform && getAuthorizationData && getAuthorizationData['id_areaAbrangencia'].value)
                    "
                ></b-form-select>

                <NoAuthorizationMsgPP
                    v-if="isPlatform && getAuthorizationData && !getAuthorizationData['id_areaAbrangencia'].value"
                />

                <b-form-invalid-feedback :state="validateState('area')">
                    Campo obrigatório
                </b-form-invalid-feedback>
            </b-form-group>

            <hr class="line" />

            <div class="footer-buttons">
                <b-button
                    :variant="'secondary'"
                    class="radius-6"
                    @click="$router.push({ name: 'AboutInitiativeForm1' })"
                    v-if="!showFooterButtons"
                    >Voltar</b-button
                >

                <b-button type="submit" :variant="'primary'" class="radius-6 submit" v-if="!showFooterButtons"
                    >Próximo</b-button
                >

                <div class="display-initial" v-if="showFooterButtons">
                    <b-button :variant="'secondary'" @click="changeRegisterForm('AboutInitiativeForm1')"
                        >Voltar</b-button
                    >

                    <b-button :variant="'primary'" @click="changeRegisterForm('AboutInitiativeForm3')">
                        Próximo
                    </b-button>
                </div>

                <b-button
                    variant="success"
                    :disabled="
                        (form.initiativeYearCreated !== null &&
                            form.initiativeYearCreated.length > 0 &&
                            form.initiativeYearCreated.length < 4) ||
                            (form.phone !== null && form.phone.length > 0 && form.phone.length < 15)
                    "
                    @click=";(isUpdate = true), onSubmit()"
                    v-if="getEditionMode && !getIsDisabled"
                >
                    Salvar
                </b-button>
            </div>
        </b-form>

        <DangerModalPP ref="warningModal" :message="message" />
    </div>
</template>

<script>
import axios from 'axios'
import { mapActions } from 'vuex'
import { required, minLength } from 'vuelidate/lib/validators'
import DangerModalPP from '@/ui/modal/danger-modal-pp/DangerModalPP'
import LockPP from '@/ui/lock-pp/LockPP'
import { AboutInitiativeApi } from '../../api/about-initiative'
import { CepLocationApi } from '../../api/cep-location'
import { AuthorizationApi } from '../../api/admin/authorization-api'
import NoAuthorizationMsgPP from '@/ui/no-authorization-msg-pp/NoAuthorizationMsgPP'

const authorizationApi = new AuthorizationApi()
const aboutInitiativeApi = new AboutInitiativeApi()
const cepLocationApi = new CepLocationApi()

export default {
    components: { LockPP, DangerModalPP, NoAuthorizationMsgPP },
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        editionMode: {
            type: Boolean,
            default: false
        },
        isPlatform: {
            type: Boolean,
            default: false
        },
        receiveData: {
            default: null
        },
        showFooterButtons: {
            type: Boolean,
            default: false
        },
        userIdLogged: {
            default: null
        },
        allowAuthorization: {
            type: Boolean,
            default: false
        },
        showLock: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            isDisabled: null,
            progress: 22.16,
            initiative: null,
            message: null,
            isUpdate: false,
            loadingAddress: false,
            authorizationData: null,
            form: {
                statusLock: 1,
                initiativeYearCreated: null,
                cep: null,
                state: null,
                street: null,
                number: null,
                complement: null,
                burgh: null,
                district: {
                    selected: null,
                    options: [{ value: null, text: 'Selecione' }]
                },
                city: null,
                phone: null,
                email: null,
                area: {
                    selected: null,
                    options: [{ value: null, text: 'Selecione' }]
                }
            }
        }
    },
    validations: {
        form: {
            cep: { required, minLength: minLength(9) },
            state: { required },
            street: { required },
            burgh: { required },
            district: {
                selected: {
                    required() {
                        return !(this.form.district.selected === null && this.form.city === 'SÃO PAULO')
                    }
                }
            },
            city: { required },
            area: {
                selected: { required }
            }
        }
    },
    methods: {
        ...mapActions(['setIsLoading', 'setCurrentFormPlatform', 'setProgress', 'setShowGamificationProgress']),
        validateState(nameField) {
            const { $dirty, $error } = this.$v.form[nameField]
            return $dirty ? !$error : null
        },
        fetchRead() {
            const data = this.receiveData
            this.initiative = data

            this.form.statusLock = data.view_location === null ? 1 : data.view_location
            this.form.initiativeYearCreated = data.tempo_iniciativa_existe
            this.form.cep = data.cep
            this.form.state = data.estado
            this.form.street = data.rua
            this.form.number = data.numero
            this.form.complement = data.complemento
            this.form.burgh = data.bairro
            this.form.district.selected = data.distrito
            this.form.city = data.cidade
            this.form.phone = data.telefone_institucional
            this.form.email = data.email_institucional
            this.form.area.selected = data.id_areaAbrangencia

            this.setIsLoading(true)

            axios
                .all([aboutInitiativeApi.getArea(), aboutInitiativeApi.getDistrict()])
                .then(response => {
                    this.form.area.options.push(
                        ...response[0].data.map(item => ({ value: item.id, text: item.area_abrangencia }))
                    )

                    this.form.district.options.push(
                        ...response[1].data.map(item => ({ value: item.id, text: item.distrito }))
                    )

                    this.fetchAuthorization()
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => this.setIsLoading(false))
        },
        fetch() {
            if (this.getProgress === '19.39') {
                this.setShowGamificationProgress(true)

                setTimeout(() => {
                    this.setShowGamificationProgress(false)
                }, 12000)
            }

            this.setIsLoading(true)

            axios
                .all([
                    aboutInitiativeApi.getAboutInitiative(),
                    aboutInitiativeApi.getArea(),
                    aboutInitiativeApi.getDistrict()
                ])
                .then(response => {
                    const data = response[0].data.data
                    if (data !== null) {
                        this.initiative = data
                        this.form.statusLock = data.view_location === null ? 1 : data.view_location
                        this.form.initiativeYearCreated = data.tempo_iniciativa_existe
                        this.form.cep = data.cep
                        this.form.state = data.estado
                        this.form.street = data.rua
                        this.form.number = data.numero
                        this.form.complement = data.complemento
                        this.form.burgh = data.bairro
                        this.form.district.selected = data.distrito
                        this.form.city = data.cidade
                        this.form.phone = data.telefone_institucional
                        this.form.email = data.email_institucional
                        this.form.area.selected = data.id_areaAbrangencia
                    }

                    this.form.area.options.push(
                        ...response[1].data.map(item => ({ value: item.id, text: item.area_abrangencia }))
                    )

                    this.form.district.options.push(
                        ...response[2].data.map(item => ({ value: item.id, text: item.distrito }))
                    )
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => this.setIsLoading(false))
        },
        onSubmit(event) {
            this.$v.form.$touch()
            if (this.$v.form.$anyError) {
                return
            }

            const currentProgress = this.getProgress < this.progress ? this.progress : this.getProgress
            const data = {
                ...this.initiative,
                view_location: this.form.statusLock,
                tempo_iniciativa_existe: this.form.initiativeYearCreated,
                cep: this.form.cep,
                estado: this.form.state,
                rua: this.form.street,
                numero: this.form.number,
                complemento: this.form.complement,
                bairro: this.form.burgh,
                distrito: this.form.district.selected,
                cidade: this.form.city,
                telefone_institucional: this.form.phone,
                email_institucional: this.form.email,
                id_areaAbrangencia: this.form.area.selected,
                percentual: currentProgress
            }

            delete data['latitude']
            delete data['longitude']

            this.setIsLoading(true)
            const request = this.isUpdate
                ? aboutInitiativeApi.updateAboutInitiative(data)
                : aboutInitiativeApi.nextAboutInitiative(data)

            request
                .then(response => {
                    this.setProgress(data.percentual)

                    if (this.isUpdate) {
                        this.changeStatusDisabled(true)
                    } else {
                        this.$router.push({ name: 'AboutInitiativeForm3' })
                    }
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => this.setIsLoading(false))
        },
        changeStatusDisabled(status) {
            this.isDisabled = status
        },
        changeRegisterForm(formName) {
            this.setCurrentFormPlatform(formName)
            this.scrollBehavior()
        },
        scrollBehavior(to, from, savedPosition) {
            const ele = document.getElementById('top-register-painel')
            return window.scrollTo({
                top: ele.offsetTop,
                behavior: 'smooth'
            })
        },
        getAddressByCep() {
            if (this.form.cep) {
                this.form.burgh = null
                this.form.city = null
                this.form.street = null
                this.form.state = null
                this.form.number = null
                this.form.complement = null
                this.form.district.selected = null
                this.loadingAddress = true

                this.setIsLoading(true)

                cepLocationApi
                    .getCep(this.form.cep.replaceAll('.', ''))
                    .then(response => {
                        if (response.data.data) {
                            const result = response.data.data
                            this.form.burgh = result.Bairro
                            this.form.city = result.Cidade
                            this.form.street = result.Classificacao + result.Endereco
                            this.form.state = result.UF
                            this.form.complement = result.Complemento
                        }
                    })
                    .catch(() => {
                        this.message = 'CEP inválido'
                        this.$refs.warningModal.showModal()
                    })
                    .finally(() => {
                        this.loadingAddress = false
                        this.setIsLoading(false)
                    })
            }
        },
        fetchAuthorization() {
            if (this.allowAuthorization) {
                this.setIsLoading(true)

                authorizationApi
                    .getAboutInitiative(this.userIdLogged)
                    .then(response => {
                        if (response.data.data === null || response.data.data.length === 0) {
                            this.authorizationData = null
                        } else {
                            this.authorizationData = response.data.data
                        }
                    })
                    .catch(error => {
                        this.message = error.response.data.message
                        this.$refs.warningModal.showModal()
                    })
                    .finally(() => {
                        this.setIsLoading(false)
                    })
            }
        }
    },
    computed: {
        getEditionMode() {
            return this.editionMode
        },
        showDistrict() {
            return this.form.city && this.form.city.toLowerCase() === 'são paulo'
        },
        getIsDisabled() {
            return this.isDisabled
        },
        getProgress() {
            return this.$store.state.progress
        },
        getIsDarkTheme() {
            return this.$store.state.darkTheme
        },
        getAuthorizationData() {
            return this.authorizationData
        }
    },
    created() {
        this.isDisabled = this.disabled
        this.receiveData === null ? this.fetch() : this.fetchRead()
    }
}
</script>

<style scope src="./AboutInitiativeForm2-light-theme.css"></style>



// WEBPACK FOOTER //
// src/components/register-about-initiative-forms/AboutInitiativeForm2.vue